<form [formGroup]="changePassForm" *ngIf="formChangePass">
  <div class="row flex-column pb-2 align-items-end container-form">

    <!-- Campo Contraseña nueva -->
    <div class="col-12">
      <label class="text-white">Contraseña nueva</label>
      <div class="password-input">
        <input
          class="form-control"
          placeholder="●●●●●●●"
          [type]="showPassword ? 'text' : 'password'"
          formControlName="password"
          [class.is-invalid]="changePassForm.get('password')?.invalid && changePassForm.get('password')?.touched"
        >
        <button class="password-toggle-btn" type="button" (click)="togglePasswordVisibility()">
          <i class="fa" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
        </button>
      </div>

      <!-- Mensajes de error de contraseña -->
      <div class="password-requirements" *ngIf="changePassForm.get('password')?.touched">
        <span class="s-sm booking" *ngIf="changePassForm.get('password')?.errors?.minlength">
          ✗ La contraseña debe tener al menos 12 caracteres.
        </span>
        <span class="s-sm booking" *ngIf="changePassForm.get('password')?.errors?.passwordWeak">
          ✗ La contraseña debe contener:<br>
          &nbsp;&nbsp;• Al menos una mayúscula (A-Z)<br>
          &nbsp;&nbsp;• Al menos una minúscula (a-z)<br>
          &nbsp;&nbsp;• Al menos un número (0-9)<br>
          &nbsp;&nbsp;• Al menos un carácter especial (!#$%^&*)
        </span>
      </div>

      <!-- Indicador de fortaleza -->
      <div class="password-strength mt-1" *ngIf="changePassForm.get('password')?.value">
        <div class="strength-bar" [class]="getPasswordStrength()"></div>
        <small class="text-white-50">Fortaleza: {{ getStrengthText() }}</small>
      </div>
    </div>

    <!-- Campo Repetir contraseña -->
    <div class="col-12 mt-2">
      <label class="text-white">Repita la contraseña</label>
      <div class="password-input">
        <input
          class="form-control"
          placeholder="●●●●●●●"
          [type]="showPasswordConfirm ? 'text' : 'password'"
          formControlName="confirmPassword"
          [class.is-invalid]="changePassForm.hasError('passwordMismatch') && changePassForm.get('confirmPassword')?.touched"
        >
        <button class="password-toggle-btn" type="button" (click)="togglePasswordConfirmVisibility()">
          <i class="fa" [ngClass]="showPasswordConfirm ? 'fa-eye-slash' : 'fa-eye'"></i>
        </button>
      </div>

      <span class="s-sm booking text-danger" *ngIf="changePassForm.hasError('passwordMismatch') && changePassForm.get('confirmPassword')?.touched">
        ✗ Las contraseñas no coinciden.
      </span>
    </div>

    <!-- Botones -->
    <div class="mt-3">

       <button
        type="button"
        class="btn border-white btn-send mt-4"
        style="margin-right: 1em;"
        (click)="onGeneratePassword()"
      >
        Generar contraseña segura
      </button>

      <button
        type="button"
        class="btn border-white btn-send mt-4"
        style="margin-right: 1em;"
        (click)="onClick(); onSubmit()"
        [disabled]="!changePassForm.valid"
      >
        Enviar
      </button>
      <button
        type="button"
        class="btn border-white btn-send mt-4"
        style="margin-right: 1em;"
        (click)="closeChangePass()"
      >
        Cerrar
      </button>
    </div>
  </div>
</form>
